import { render } from "./Tem024.vue?vue&type=template&id=a01395ec&scoped=true"
import script from "./Tem024.vue?vue&type=script&lang=js"
export * from "./Tem024.vue?vue&type=script&lang=js"

import "./Tem024.vue?vue&type=style&index=0&id=a01395ec&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a01395ec"]])

export default __exports__